<script>
import { Form, Field, Toast, Dialog } from 'vant'
import ImageUploader from '@/fcl/components/user/ImageUploader'
import TextSwitcher from '@/fcl/components/user/TextSwitcher'
import CheckboxListSelector from '@/fcl/components/user/CheckboxListSelector'
import BottomToolbar from '@/fcl/components/user/BottomToolbar'
import Staff from '@/fcl/tbs/model/vo/Staff'
import { QNImageUtil } from '@/fcl/utils'

export default {
    //--------------------------------------------------
	// component name
	//--------------------------------------------------
	name: 'org-staff-edit',

    //--------------------------------------------------
	// component components
	//--------------------------------------------------
    components: {
        'van-form': Form,
        'van-field': Field,
        'image-uploader': ImageUploader,
        'text-switcher': TextSwitcher,
        'checkbox-list-selector': CheckboxListSelector,
        'bottom-toolbar': BottomToolbar,
    },

    //--------------------------------------------------
    // component emits
    //--------------------------------------------------
	emits: ['custom-event'],

    //--------------------------------------------------
    // component data
    //--------------------------------------------------
    data() {
        return {
            staff: {
                id: null,
                organizationId: null,
                name: null,
                roleList: null,
                remark: null,
                isLogon: null,
                isSuperAdmin: null,
            },
            matchId: null,
            isEdit: null,
            locale: {}
        }
    },
    
    //--------------------------------------------------
    // computed setter and getter
    //--------------------------------------------------
    computed: {
        roleOptions() {
            return (new Staff).getRoleOptions()
        }
    },

    //--------------------------------------------------
    // component methods
    //--------------------------------------------------
    methods: {
        onSubmitBtnClick() {
            console.log('onSubmitBtnClick')
            if (!this.validateSubmitRequired()) {
                // disable to submit and toast the message
                if (!this.staff.name) {
                    Toast(this.locale['staff-name-required'])
                }
                else if (!this.staff.roleList || !this.staff.isSuperAdmin) {
                    Toast(this.locale['staff-role-required'])
                }
            }
            else {
                // enable to submit
                this.submitData()
            }
        },
        onDeleteBtnClick() {
            console.log('onDeleteBtnClick')
            Dialog.confirm({
                title: this.locale['delete-staff'],
                message: this.locale['delete-staff-confirm-message']
            }).then(() => {
                // on confirm
                this.$emit('custom-event', {
                    type: 'delete'
                })
            }).catch(() => {
                // on cancel
            })
        },
        onSuperAdminDataChange(data) {
            console.log('onSuperAdminDataChange', data)
            this.staff.isSuperAdmin = data
        },
        onRoleListDataChange(data) {
            console.log('onRoleListDataChange', data)
            this.staff.roleList = data
        },
        //--------------------------------------------------
        // private method
        //--------------------------------------------------
        /**
         * @private
         * Adjust the image url according to the width and height.
         * @param img The identifier string for the image source.
         * @param w The image width number.
         * @param h The image height number.
         * @return The completed full url string.
         */
		adjustImageSize(img, w, h) {
            // console.log('adjustImageSize', img, w, h)
            if (img) {
                return QNImageUtil.imageView(img, w, h)
            }
			else {
                return null
            }
		},
        validateSubmitRequired() {
            // console.log('validateSubmitRequired')
            if (this.staff.name 
                && (this.staff.roleList || this.staff.isSuperAdmin)) {
                return true
            }
            else {
                return false
            }
        },
        submitData() {
            if (this.validateSubmitRequired()) {
                this.$emit('custom-event', {
                    type: 'save',
                    data: this.staff
                })
            }
        }
    },
}
</script>

<template>
    <div class="staff-edit">
        <van-form>
            <van-field 
                name="staff-name" 
                v-model="staff.name" 
                :label="locale['staff-name-label']" :placeholder="locale['staff-name-placeholder']"
                clearable
                input-align="right"
                maxlength="30" 
            />
            <text-switcher 
                :label="locale['staff-super-admin-label']"
                :checked="staff.isSuperAdmin"
                @change-data="onSuperAdminDataChange"
            />
            <checkbox-list-selector
                v-if="!staff.isSuperAdmin"
                :label="locale['staff-role-label']"
                :value="staff.roleList"
                :list="roleOptions"
                @change-data="onRoleListDataChange"
            />
            <van-field 
                name="staff-remark" 
                v-model="staff.remark" 
                :label="locale['staff-remark-label']" :placeholder="locale['staff-remark-placeholder']"
                clearable
                input-align="right"
                type="textarea"
                rows="1"
                autosize
                maxlength="100" 
            />
        </van-form>
        <bottom-toolbar 
            v-if="!isEdit"
            type="button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            @click-main-button="onSubmitBtnClick"
        />
        <bottom-toolbar 
            v-else
            type="button-button" 
            :mainButtonLabel="locale['submit']"
            :mainButtonDisabled="!validateSubmitRequired()"
            :minorButtonLabel="locale['delete']"
            @click-main-button="onSubmitBtnClick"
            @click-minor-button="onDeleteBtnClick"
        />
    </div>
</template>